import { useMutation, MutationHookOptions, gql } from "@apollo/client"

const BulkUpdateTerminations = gql`
  mutation UpdateBulkTerminations(
    $bulkOffboardingId: ID!
    $proposedDate: ISO8601Date
    $reason: String
    $communicatedWithEmployee: Boolean
    $intendedDaysOff: Float
    $ptoAccurate: Boolean
    $ptoInaccurateNote: String
    $notes: String
    $state: TerminationState
    $primaryCategoryId: ID
    $secondaryCategoryId: ID
    $notifyCustomerAdmin: Boolean
    $onLeave: Boolean
    $copyPaymentsFromTerminationId: ID
  ) {
    bulkUpdateTerminations(
      input: {
        bulkOffboardingId: $bulkOffboardingId
        proposedDate: $proposedDate
        reason: $reason
        communicatedWithEmployee: $communicatedWithEmployee
        intendedDaysOff: $intendedDaysOff
        ptoAccurate: $ptoAccurate
        ptoInaccurateNote: $ptoInaccurateNote
        notes: $notes
        state: $state
        primaryCategoryId: $primaryCategoryId
        secondaryCategoryId: $secondaryCategoryId
        notifyCustomerAdmin: $notifyCustomerAdmin
        onLeave: $onLeave
        copyPaymentsFromTerminationId: $copyPaymentsFromTerminationId
      }
    ) {
      errors
    }
  }
`

export const useBulkUpdateTerminations = (options?: MutationHookOptions) => {
  return useMutation(BulkUpdateTerminations, options)
}
